// Add your JS customizations here
jQuery(document).ready(function($) { 
	
	//inizialize WOW
	//new WOW().init();

	//enables Font Awesome pseudo elements
	window.FontAwesomeConfig = {
		searchPseudoElements: true
	}

		//Variables
	let wSize = $( window ).width();
	const $root = $( 'html, body' );
	let topHeader = $('.top-menu-sidebar ');
	let topheaderHeight = $( topHeader ).outerHeight( true );

	//add active class to body
	$( 'body' ).addClass( 'active' )

	$('.header_trigger').css( 'margin-top', topheaderHeight );

	if ( wSize >= 992 ) {
		$( '.match-height' ).matchHeight();
		//Open courses submenu
		 $('.menu-item-99').click( function( e ) {
			e.preventDefault();
		      $('#courses-menu-wrapper').toggleClass('show');  
		  });

		 $('.open-courses-menu').click(function (e) {
			 e.preventDefault();
			 $('#courses-menu-wrapper').addClass('show');  
		});

	 //Close courses submenu	
		 $('#courses-menu-wrapper .close').click(function (e) {
		 	e.preventDefault();
		      $('#courses-menu-wrapper').removeClass('show'); 
		       
		 })

		 let fooHeight = $('#stay-in-the-loop').outerHeight(true);
		 let mark_Loop = $('#stay-in-the-loop .watermark ');
		 let fooInfo = $('.site-info').outerHeight(true);
		 let graphicFoo = $('.site-info .graphic ');
		 $(mark_Loop).height(fooHeight);
		 $(mark_Loop).css('object-fit', 'cover');
		 $(graphicFoo).height(fooInfo);
		 $(graphicFoo).css('object-fit', 'cover');
		 console.log(fooHeight);
		 

	}

	if ( wSize <= 992 ) {
		$( '.match-height_mob' ).matchHeight();
		//Menu Mob
		$( '.hamburger' ).click( function( e ) {
			e.preventDefault();
			$( this ).toggleClass( 'is-active' );
			$( 'body, html' ).toggleClass( 'modal-open' );
			$(topHeader).toggleClass('open-mob');
			$( '#main-menu-wrapper-mob' ).fadeToggle( 600 );
			$( '#main-menu-wrapper-mob' ).toggleClass( 'center' );
			if (  $('#courses-menu-wrapper').hasClass('show') )  {
				$('#courses-menu-wrapper').removeClass('show');
			}
		} );


	 //Close courses submenu	
		 $('#courses-menu-wrapper .close').click(function (e) {
		 	e.preventDefault();
		      $('#courses-menu-wrapper').removeClass('show'); 
		 });

		$('#courses-menu-wrapper').css( 'margin-top', topheaderHeight );
		$('#main-menu-wrapper-mob').css( 'margin-top',topheaderHeight);

		if ( $( 'body' ).hasClass( 'page-template-home-page' ) ) {
			
		}
		if ( $( 'body' ).hasClass( 'single-product' ) ){
			$('#main-menu-wrapper-mob').css( 'margin-top','0' );
			$('#courses-menu-wrapper').css( 'margin-top', '0' );
		}
		$('button#gform_submit_button_1').html('SIGN UP');

		//because here the menu is hidden
		 $(document).on('click', '.menu-item-99 a', function (e) {
		 	e.preventDefault();
		      $('#courses-menu-wrapper').addClass('show'); 
		 });

		  $('.open-courses-menu').click(function (e) {
			 e.preventDefault();
			 $( '.hamburger' ).toggleClass( 'is-active' );
			 $( 'body, html' ).toggleClass( 'modal-open' );
			 $(topHeader).toggleClass('open-mob');
			 $( '#main-menu-wrapper-mob' ).fadeToggle( 600 );
			 $( '#main-menu-wrapper-mob' ).toggleClass( 'center' );
			 if ( ! $('#courses-menu-wrapper').hasClass('show') )  {
				$('#courses-menu-wrapper').addClass('show');  
			}
		});
	}

	//ON SCROLL
	$( window ).on( 'scroll', function() {

	} );
	//ON RESIZE
	
	$( window ).on( 'resize', function() {
		if ( wSize >= 992 ) {
			 let fooHeight = $('#stay-in-the-loop').outerHeight(true);
			 let fooInfo = $('.site-info').outerHeight(true);
			 let graphicFoo = $('.site-info .graphic ');
			 let mark_Loop = $('#stay-in-the-loop .watermark ');
			 $(mark_Loop).height(fooHeight);
			 $(graphicFoo).height(fooInfo);
		}
	} );

	  $(window).load(function() {
        // will only fire AFTER all pages assets have loaded
       
    })
	  $('.hero-img_animated_on_load, .animated_on_load ').addClass( 'slide-active' );

	// the event needs to be run before slick is initialized - the
	$( '.slick-slider' ).on( 'init', function( event, slick, direction ) {


		// check to see if there are one or less slides and hide the arrows accordingly
		if ( !( $( '.slick-slider .slick-slide' ).length > 2 ) ) {
			
			if ( $( 'body' ).hasClass( 'page-template-home-page' ) ) {
				$( '.slick-dots' ).hide();
			}
		}

	} );

	//Slick
//$( '.before_after_slider' ).slick( {
//	slidesToScroll: 1,
//	slidesToShow: 1,
//	arrows: true,
//	dots: false,
//	infinite: false,
//	prevArrow: $( '.bef_after-prev' ),
//	nextArrow: $( '.bef_after-next' ),
//	autoplay: false,
//} );

	$( '.before_after_slider_mob' ).slick( {
		slidesToScroll: 1,
		slidesToShow: 1,
		arrows: false,
		dots: false,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 6000,
 		speed: 4000,
	} );

	$('.courses-slider').slick({
		dots: true,
		centerMode: false,
		centerPadding: '95px',
		slidesToScroll: 1,
		slidesToShow: 2,
		arrows: false,
		infinite: false,
		responsive: [{
			breakpoint: 576,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				centerMode: false,
				centerPadding: '30px',
			}
		}]
	});


//Awards Slick
 	$('.logos-carousel').slick({
 		centerPadding: '80px',
 		autoplay: true,
 		infinite: true,
 		slidesToShow: 5,
 		slidesToScroll: 1,
 		arrows: false,
 		autoplaySpeed: 6000,
 		speed: 4000,

 		responsive: [{
 			breakpoint: 1024,
 			settings: {
 				slidesToShow: 3,
 				slidesToScroll: 1,

 			}
 		}, {
 			breakpoint: 600,
 			settings: {
 				slidesToShow: 2,
 				slidesToScroll: 1,
 				fade: true,
 				autoplaySpeed: 6000,
 				speed: 500,
 				cssEase: 'ease-in-out',
 				cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
 				touchThreshold: 100
 			}
 		}, {
 			breakpoint: 480,
 			settings: {
 				slidesToShow: 2,
 				slidesToScroll: 1,
 				autoplaySpeed: 7000,
 			}
 		}]
 	});
	//Sidebar dropdowns
	$( '.desktop-sidebar #cat' ).select2( {
		placeholder: "Category",
		minimumResultsForSearch: Infinity,
		allowClear: false,
		width: '100%',
	} );
	$( '.desktop-sidebar #archives-dropdown-2' ).select2( {
		placeholder: "Archives",
		minimumResultsForSearch: Infinity,
		allowClear: false,
		width: '100%',
	} );
	
	//Sidebar dropdowns
	$( '.gfield_select' ).select2( {
		minimumResultsForSearch: Infinity,
		allowClear: false,
		width: '100%',
	} );

	$( 'b[role="presentation"]' ).hide();
	$( '.select2-selection__arrow' ).append( '<i class="text-black fa-light fa-arrow-down"></i>' );


if ( $( 'body' ).hasClass( 'page-template-free-rosources' ) ) {

	$('#instructional-videos .videos .resource-link').click(function(e) {
		e.preventDefault();
		var dataLink = $(this).data('link');
		$('#input_4_5').val(dataLink);
		$('#form_pop_up .form-title span').text( `${dataLink}`);
		$('#form_pop_up').addClass('show');
		$( 'body, html' ).addClass( 'modal-open' );
		window.lintrk('track', { conversion_id: 12044522 }); 
		
	});;

	$('#form_pop_up .close').click(function(e) {
		e.preventDefault();
		$('#form_pop_up').removeClass('show');
		$(this).parents('#form_pop_up').find('.form-title span').text('');
		$( 'body, html' ).removeClass( 'modal-open' );
	});

	$('#downloable-files .files .resource-link').click(function(e) {
		e.preventDefault();
		var dataLink = $(this).data('link');
		$('#input_4_5').val(dataLink);
		$('#form_pop_up .form-title span').text( `${dataLink}`);
		$('#form_pop_up').addClass('show');
		$( 'body, html' ).addClass( 'modal-open' );
	});


}

if ( $( 'body' ).hasClass( 'page-template-become-model' ) ) {

	$('.show-form').click( function( e ) {
		e.preventDefault();
		$('.hidden_on_load').slideDown(600);
		$('.hidden_on_load').addClass('show');
		$('.invisible_on_load').addClass('show');
	} );

	$('.show-list').click( function( e ) {
		e.preventDefault();
		$('.form-wrapper_history_list').slideDown(600);
		$('.form-wrapper_history_list').addClass('show');

	} );

	$('#gform_wrapper_3 #gform_browse_button_3_79').text('CHOOSE YOUR FILES');
	$('#gform_wrapper_3 #gform_browse_button_3_79').addClass('bt bg_black');

	//Be a Model Form -they are a lots, I know...

		// Personal Details	and Address	
		$('input[name="first_name"]').keyup(function() {
			var input=$(this);
			var re_name=/^([a-zA-Z]+\s)*[a-zA-Z]+$/;
			var is_name=re_name.test(input.val());
			if( is_name || $(this).val() !== "" ){
				var element=$('input[name="first_name"]');
				var error_element=$("span", element.parent());
				input.removeClass("invalid").addClass("valid");
				error_element.removeClass("error_show").addClass("error");
				$('#input_3_4').val($(this).val());
				consoloe
			}
			else{
				var element=$('input[name="first_name"]');
				var error_element=$("span", element.parent());
				error_element.removeClass("error").addClass("error_show");
				input.removeClass("valid").addClass("invalid");

			}
		});
		$('input[name="surname"]').keyup(function() {
			var input=$(this);
			var re_surname=/^([a-zA-Z]+\s)*[a-zA-Z]+$/;
			var is_surname=re_name.test(input.val());
			if(is_surname){
				var element=$('input[name="surname"]');
				var error_element=$("span", element.parent());
				input.removeClass("invalid").addClass("valid");
				error_element.removeClass("error_show").addClass("error");
				$('#input_3_5').val($(this).val());
			}
			else{
				var element=$('input[name="surname"]');
				var error_element=$("span", element.parent());
				error_element.removeClass("error").addClass("error_show");
				input.removeClass("valid").addClass("invalid");

			}
		
		});
		$('input[name="gender"]').keyup(function() {
			$('#input_3_6').val($(this).val());
		});
		$('input[name="address_1"]').keyup(function() {
			$('#input_3_7').val($(this).val());
		});
		$('input[name="address_2"]').keyup(function() {
			$('#input_3_8').val($(this).val());
		});
		$('input[name="city"]').keyup(function() {
			$('#input_3_10').val($(this).val());
		});
		$('input[name="region"]').keyup(function() {
			$('#input_3_11').val($(this).val());
		});
		$('input[name="postcode"]').keyup(function() {
			$('#input_3_12').val($(this).val());
		});
		$('input[name="date_of_birth"]').keyup(function() {
			$('#input_3_13').val($(this).val());
		});
		$('input[name="email_address"]').keyup(function() {
			var input=$(this);
			var re_email = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
			var is_email=re_email.test(input.val());
			if(is_email){
				var element=$('input[name="email_address"]');
				var error_element=$("span", element.parent());
				input.removeClass("invalid").addClass("valid");
				error_element.removeClass("error_show").addClass("error");
				$('#input_3_14').val($(this).val());
			}
			else{
				var element=$('input[name="email_address"]');
				var error_element=$("span", element.parent());
				error_element.removeClass("error").addClass("error_show");
				input.removeClass("valid").addClass("invalid");
			}
		});
		$('input[name="mobile_number"]').keyup(function() {
			var input=$(this);
			var re_phone = /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/;
			var is_phone=re_phone.test(input.val());
			if(is_phone  || $(this).val() === "" ){
				var element=$('input[name="mobile_number"]');
				var error_element=$("span", element.parent());
				input.removeClass("invalid").addClass("valid");
				error_element.removeClass("error_show").addClass("error");
				$('#input_3_15').val($(this).val());
			}
			else{
				var element=$('input[name="mobile_number"]');
				var error_element=$("span", element.parent());
				error_element.removeClass("error").addClass("error_show");
				input.removeClass("valid").addClass("invalid");
			}
		});

		$('input[name="address_1"]').keyup(function() { 
			var is_address =$(this);
			if(is_address.val()!== ""){
				var element=$('input[name="address_1"]');
				var error_element=$("span", element.parent());
				is_address.removeClass("invalid").addClass("valid");
				error_element.removeClass("error_show").addClass("error");
				$('#input_3_7').val($(this).val());
			}
			else{
				var element=$('input[name="address_1"]');
				var error_element=$("span", element.parent());
				error_element.removeClass("error").addClass("error_show");
				is_address.removeClass("valid").addClass("invalid");
			}

		});

		$('input[name="gender"]').keyup(function() { 
			var is_address =$(this);
			if(is_address.val()!== ""){
				var element=$('input[name="gender"]');
				var error_element=$("span", element.parent());
				is_address.removeClass("invalid").addClass("valid");
				error_element.removeClass("error_show").addClass("error");
				$('#input_3_6').val($(this).val());
			}
			else{
				var element=$('input[name="gender"]');
				var error_element=$("span", element.parent());
				error_element.removeClass("error").addClass("error_show");
				is_address.removeClass("valid").addClass("invalid");
			}

		});

		// Allergies and general info
		$('textarea[name="allergies"]').on('change keyup paste', function() {
			$('#input_3_16').val($(this).val());
		});
		$('input[name="pregnant"]').change(function() {
			$('#input_3_17').val('Yes');
		});
		$('input[name="no_pregnant"]').keyup(function() {
			$('#input_3_18').val('No');
		});
		$('input[name="breastfeeding"]').keyup(function() {
			$('#input_3_19').val('Yes');
		});
		$('input[name="no_breastfeeding"]').keyup(function() {
			$('#input_3_20').val('No');
		});

		// Medical conditions
		$('input[name="allergies_none"]').change(function() {
			$('#input_3_21').val('No');
		});
		$('input[name="haemophilia"]').change(function() {
			$('#input_3_22').val('Yes');
		});
		$('input[name="radiotherapy"]').change(function() {
			$('#input_3_88').val('Yes');
		});
		$('input[name="heart_attack"]').change(function() {
			$('#input_3_24').val('Yes');
		});
		$('input[name="other_blood_conditions"]').change(function() {
			$('#input_3_23').val('Yes');
		});
		$('input[name="chemotherapy"]').change(function() {
			$('#input_3_26').val('Yes');
		});
		$('input[name="stroke"]').change(function() {
			$('#input_3_27').val('Yes');
		});
		$('input[name="bronchitis"]').change(function() {
			$('#input_3_28').val('Yes');
		});
		$('input[name="joint_or_bone_diseases"]').change(function() {
			$('#input_3_29').val('Yes');
		});
		$('input[name="angina"]').change(function() {
			$('#input_3__30').val('Yes');
		});
		$('input[name="emphysema"]').change(function() {
			$('#input_3_31').val('Yes');
		});
		$('input[name="depression"]').change(function() {
			$('#input_3_32').val('Yes');
		});
		$('input[name="pacemaker"]').change(function() {
			$('#input_3_33').val('Yes');
		});
		$('input[name="pneumonia"]').change(function() {
			$('#input_3_34').val('Yes');
		});
		$('input[name="schizofrenia"]').change(function() {
			$('#input_3_35').val('Yes');
		});
		$('input[name="irregular_heartbeat"]').change(function() {
			$('#input_3_36').val('Yes');
		});
		$('input[name="cystic_fibrosis"]').change(function() {
			$('#input_3_37').val('Yes');
		});
		$('input[name="parkinsons_disease"]').change(function() {
			$('#input_3_38').val('Yes');
		});
		$('input[name="heart_surgery"]').change(function() {
			$('#input_3_39').val('Yes');
		});
		$('input[name="copd"]').change(function() {
			$('#input_3_40').val('Yes');
		});
		$('input[name="myasthenia_gravis"]').change(function() {
			$('#input_3_41').val('Yes');
		});
		$('input[name="high_blood_pressure"]').change(function() {
			$('#input_3_42').val('Yes');
		});
		$('input[name="asthma"]').change(function() {
			$('#input_3_43').val('Yes');
		});
		$('input[name="epilepsy"]').change(function() {
			$('#input_3_44').val('Yes');
		});
		$('input[name="low_blood_pressure"]').change(function() {
			$('#input_3_45').val('Yes');
		});
		$('input[name="chest_surgery"]').change(function() {
			$('#input_3_48').val('Yes');
		});
		$('input[name="other_nervous_problem_disease"]').change(function() {
			$('#input_3_46').val('Yes');
		});
		$('input[name="rheumatic_disease"]').change(function() {
			$('#input_3_47').val('Yes');
		});
		$('input[name="other_chest_conditions"]').change(function() {
			$('#input_3_49').val('Yes');
		});
		$('input[name="eczema"]').change(function() {
			$('#input_3_50').val('Yes');
		});
		$('input[name="other_heart_condition"]').change(function() {
			$('#input_3_51').val('Yes');
		});
		$('input[name="liver_disease"]').change(function() {
			$('#input_3_52').val('Yes');
		});
		$('input[name="psoriasis"]').change(function() {
			$('#input_3_53').val('Yes');
		});
		$('input[name="hepatitis"]').change(function() {
			$('#input_3_54').val('Yes');
		});
		$('input[name="kidney_disease"]').change(function() {
			$('#input_3_55').val('Yes');
		});
		$('input[name="scleroderma"]').change(function() {
			$('#input_3_56').val('Yes');
		});
		$('input[name="hiv_aids"]').change(function() {
			$('#input_3_57').val('Yes');
		});
		$('input[name="diabetes"]').change(function() {
			$('#input_3_58').val('Yes');
		});
		$('input[name="vitiligo"]').change(function() {
			$('#input_3_59').val('Yes');
		});
		$('input[name="refused_transfusion"]').change(function() {
			$('#input_3_60').val('Yes');
		});
		$('input[name="acid_reflux"]').change(function() {
			$('#input_3_61').val('Yes');
		});
		$('input[name="dermatitis"]').change(function() {
			$('#input_3_62').val('Yes');
		});
		$('input[name="abnormal_blood_tests"]').change(function() {
			$('#input_3_63').val('Yes');
		});
		$('input[name="hiatus_hernia"]').change(function() {
			$('#input_3_64').val('Yes');
		});
		$('input[name="cold_cores"]').change(function() {
			$('#input_3_65').val('Yes');
		});
		$('input[name="anaemia"]').change(function() {
			$('#input_3_66').val('Yes');
		});
		$('input[name="anorexia_bulimia"]').change(function() {
			$('#input_3_67').val('Yes');
		});
		$('input[name="sickle_cell"]').change(function() {
			$('#input_3_89').val('Yes');
		});
		$('input[name="cancer"]').change(function() {
			$('#input_3_68').val('Yes');
		});


		// Other allergies and medications
		$('textarea[name="other_allergies"]').on('change keyup paste', function() {
			$('#input_3_90').val($(this).val());
		});
		$('textarea[name="any_medication"]').on('change keyup paste', function() {
			$('#input_3_91').val($(this).val());
		});
		$('input[name="dismorphia"]').change(function() {
			$('#input_3_92').val('Yes');
		});
		$('input[name="yes_smoking"]').change(function() {
			$('#input_3_70').val('Yes');
		});
		$('input[name="no_smoking"]').change(function() {
			$('#input_3_69').val('No');
		});
		$('input[name="how_many"]').keyup(function() {
			$('#input_3_94').val($(this).val());
		});
		$('input[name="drinking"]').change(function() {
			$('#input_3_71').val('Yes');;
		});
		$('input[name="no_drinking"]').change(function() {
			$('#input_3_72').val('No');
		});
		$('input[name="sunbathe"]').change(function() {
			$('#input_3_73').val('Yes');
		});
		$('input[name="no_sunbathe"]').change(function() {
			$('#input_3_74').val('No');
		});
		$('textarea[name="facial_areas"]').on('change keyup paste', function() {
			$('#input_3_75').val($(this).val());
		});
		$('textarea[name="aesthetics_treatments"]').on('change keyup paste', function() {
			$('#input_3_76').val($(this).val());
		});


		// Error Message here
		/*
		if ( $('.gform_submission_error').length > 0) {
			$('.application-form ').prepend(
				'<div class="outer-padding"><h2 class="fs24 text-orange mb-0 pb-30 pb-lg-40"><span class="gform-icon gform-icon--close"></span>There was a problem with your submission. Please review the form and try again.</h2></div>'
			);
		} 
		*/

		$(document).on('click', '#gform_submit_button_3', function () {
			if( $('input[name="email_address"]').val() === "" || $('input[name="first_name"]').val() === "" || $('input[name="surname"]').val() === "" || $('input[name="gender"]').val() === ""){
				//alert('name can be empty!');
				$('input[name="email_address"]').removeClass("error_show").addClass("error");
				$('input[name="email_address').parents('.col-12').find('.error').show();
				$('#gform_submit_button_3').addClass('disabled');
			}
		});


	$('input[name="first_name"]').blur(function() {
		if ($(this).hasClass('valid') && $('input[name="surename"]').hasClass('valid') && $('input[name="email_address"]').hasClass('valid') && $('input[name="mobile_number"]').hasClass('valid')) {
			$('#gform_submit_button_3').removeClass('disabled');
			$('.date_disable').removeClass('date_disable');
		} else {
			$('#gform_submit_button_3').addClass('disabled');
		}
	});


	$('input[name="surname"]').blur(function() {
		if ($(this).hasClass('valid') && $('input[name="first_name"]').hasClass('valid') && $('input[name="email_address"]').hasClass('valid') && $('input[name="mobile_number"]').hasClass('valid')) {
			$('#gform_submit_button_3').removeClass('disabled');
			$('.date_disable').removeClass('date_disable');
		} else {
			$('#gform_submit_button_3').addClass('disabled');
		}
	});

	$('input[name="email_address"]').blur(function() {
		if ($(this).hasClass('valid') && $('input[name="first_name"]').hasClass('valid')  && $('input[name="surename"]').hasClass('valid') && $('input[name="mobile_number"]').hasClass('valid')) {
			$('#gform_submit_button_3').removeClass('disabled');
			$('.date_disable').removeClass('date_disable');
		} else {
			$('#gform_submit_button_3').addClass('disabled');
		}
	});

	$('input[name="phone_number"]').blur(function() {
		if ($(this).hasClass('valid') && $('input[name="first_name"]').hasClass('valid')  && $('input[name="surename"]').hasClass('valid') && $('input[name="email_address"]').hasClass('valid')) {
			$('#gform_submit_button_3').removeClass('disabled');
			$('.date_disable').removeClass('date_disable');
		} else {
			$('#gform_submit_button_3').addClass('disabled');
		}
	});


}
	//WOOCOMMERCE

	// Login Form Submit

	$(document).on('click', '.login-submit-btn', function (e) {
		e.preventDefault();
		login_submit($('.login-email').val(), $('.login-password').val());
	});

	function login_show_error(message) {
		$('.login-errors').show().find('.inner').empty().append('<h6 class="text-center text-white">' + message + '</h6>');
	}

	function login_show_dahborad_link() {
		$('.form-container').empty().append('<h4 class="text-center text-white">Login suceeded, please visit the <a class="text-white underline" href="https://bydesign-academy.com/dashboard/">Dashboard</a></h4>');
	}

	 function dashboardRedirect() {
        window.location.replace("https://bydesign-academy.com/dashboard/");
    }   
	function login_submit(email, pass) {

	$.ajax({
		url: ajax.url,	
		type: 'POST',
		data: { 'action': 'wc_login_submit', 'email': email, 'pass': pass },
		success: function (response) {
			if (response.length > 0) {
				login_show_error(response);
			} else {
				//window.location.reload(false);
				login_show_dahborad_link();
			}
		}
	});
}

	$(document).on('click', '.woocommerce-form-register__submit', function (e) {

		e.preventDefault(e);

		var data = {
			username: $('#reg_username').val(),
			email: $('#reg_email').val(),
			password: $('#reg_password').val(),
		};

		register_submit(data);

	});

function register_show_error(message) {
	$('.login-errors').show().find('.inner').empty().append('<ul class="list-unstyled text-white text-center">' + message + '</ul>');
}
function redirect_to_dashboard() {
	$('.login-errors').show().find('.inner').empty().append(`<h6 class="text-center text-white">
		The Acccount has been created, please login to the dashboard. Please login to the <a class="text-white" href="https://bydesign-academy.com/dashboard/">Dashboard</a></h6>`

	);
}

function register_submit(data) {

	$.ajax({
		url: ajax.url,
		type: 'POST',
		data: { 'action': 'wc_register_submit', 'data': data },
		success: function (response) {
			if (response.length > 0) {
				register_show_error(response);
			} else {
				//window.location.reload(false);
				redirect_to_dashboard();
			}
		}
	});

}


	// Update Account Submit

	$(document).on('click', '.update-account-submit-btn', function () {

		var user_id = $(this).attr('data-user-id');

		var data = {
			forename: $('.update-forename').val(),
			surname: $('.update-surname').val(),
			company: $('.update-company').val(),
			email: $('.update-email').val(),
			phone: $('.update-phone').val(),
			address1: $('.update-address1').val(),
			address2: $('.update-address2').val(),
			address3: $('.update-address3').val(),
			city: $('.update-city').val(),
			//county: $('.update-county').val(),
			postcode: $('.update-postcode').val()
		};

		update_account_submit(user_id, data);

	});



	// Update Account Submit

	$(document).on('click', '.update-password-submit-btn', function () {

		var user_id = $(this).attr('data-user-id');

		var data = {
			email: $('.update-email').val(),
			current_password: $('.current-password').val(),
			new_password: $('.new-password').val(),
			confirm_new_password: $('.confirm-new-password').val(),
		};

		update_password_submit(user_id, data);

	});

 	
	$('.play-bt').click( function( e ) {
		$(this).hide(400);
		$(this).parents('.inst-video-container').find('.overlay').hide(400);
		$(this).parents('.inst-video-container').find('.video-thumb').hide(400);
	} );

	
	//On Course pages Add To Basket Button - AJAX Add to Cart
	$('.checkout-product-add-btn').on('click', function(e) {

		event.preventDefault();
		
		var href = $(this).attr('data-href');
		var href = href.replace('***VARIATION_ID***', $(this).attr('data-variation-id'));
		var href = href.replace('***QUANTITY***', $(this).attr('data-quantity'));
		window.location.href = href;
		

	});

	// Buy Now Button

	$('.checkout-product-add-btn').on('click', function () {

		event.preventDefault();

		var href = $(this).attr('data-href');
		var href = href.replace('***VARIATION_ID***', $(this).attr('data-variation-id'));
		var href = href.replace('***QUANTITY***', $(this).attr('data-quantity'));

		window.location.href = href;

	});

	// Scroll To Book

	$('.see-availability').on('click', function (e) {
		e.preventDefault();

		var position = $('#upcoming-dates').offset().top - $(topHeader).outerHeight(false);

		$('html, body').animate({ scrollTop: position }, 250);

	});

	// Scroll To upcoming dates on About page

	$('.scroll_to-upcoming-dates').on('click', function (e) {
		e.preventDefault();

		var position = $('#upcoming-dates').offset().top - $(topHeader).outerHeight(false);

		$('html, body').animate({ scrollTop: position }, 250);

	});

	

	$('.got_to_model_form').on('click', function (e) {
		e.preventDefault();

		var position = $('#medical-history-form').offset().top - $(topHeader).outerHeight(false);

		$('html, body').animate({ scrollTop: position }, 250);

	});


	//Save course on single course page
	$(document).on('click', '.save-course-btn', function () {

		var type = 'course';
		var status = $(this).attr('data-status');
		var user_id = $(this).attr('data-user-id');
		var course_id = $(this).attr('data-course-id');

		if (user_id != 0) {

			if (status == 'saved') {

				$('.favourite[data-course-id="' + course_id + '"]').removeClass('active').attr('data-status', 'unsaved');
				unsave_item(type, user_id, course_id);
				console.log(`unsaved ${course_id}`);

			} else if (status == 'unsaved') {

				$('.favourite[data-course-id="' + course_id + '"]').addClass('active').attr('data-status', 'saved');
				save_item(type, user_id, course_id);
				console.log(`saved ${course_id}`);

			}

		} else {

			login_show_error('You must be logged in to save courses');
			$(this).removeClass('d-flex').addClass('d-none');
		}

	});
		function save_item(type, user_id, course_id, item_id) {

			if (item_id === false) {

				$.ajax({
					url: ajax.url,
					type: 'POST',
					data: { 'action': 'wc_save_item', 'type': type, 'user_id': user_id, 'course_id': course_id, 'item_id': item_id }
				});

			} else {

				$.ajax({
					url: ajax.url,
					type: 'POST',
					data: { 'action': 'wc_save_item', 'type': type, 'user_id': user_id, 'course_id': course_id, 'item_id': item_id }
				});

			}

		}

		function unsave_item(type, user_id, course_id, item_id) {

			if (item_id === false) {

				$.ajax({
					url: ajax.url,
					type: 'POST',
					data: { 'action': 'wc_unsave_item', 'type': type, 'user_id': user_id, 'course_id': course_id, 'item_id': item_id }
				});

			} else {

				$.ajax({
					url: ajax.url,
					type: 'POST',
					data: { 'action': 'wc_unsave_item', 'type': type, 'user_id': user_id, 'course_id': course_id, 'item_id': item_id }
				});

			}
		}

	function update_account_start_loading() {
		$('.update-form .row').fadeTo(250, 0);
		setTimeout(function () {
			$('.update-account-loading').addClass('active');
		}, 250);
	}

	//Triggered by update_password_submit(user_id, data) -TODO - creating a loading spinner?
	function update_account_end_loading(delay) {
		setTimeout(function () {
			$('.update-account-loading').removeClass('active');
			setTimeout(function () {
				$('.update-form .row').fadeTo(250, 100);
			}, 250);
		}, delay);
	}

	function update_password_submit(user_id, data) {

		//update_account_start_loading(); To activate it (line 655)

		//wc_update_password_submit -functions.php line 1055
		$.ajax({
			url: ajax.url,
			type: 'POST',
			data: { 'action': 'wc_update_password_submit', 'user_id': user_id, 'data': data },
			success: function (response) {
				if (response.length > 0) {
					update_password_show_error(response);
				} else {
					window.location.reload(false);
				}
			}
		});

	}

	function update_account_submit(user_id, data) {

		$.ajax({
			url: ajax.url,
			type: 'POST',
			data: { 'action': 'wc_update_account_submit', 'user_id': user_id, 'data': data },
			success: function (response) {
				if (response.length > 0) {
					update_account_show_error(response);
				} else {
					window.location.reload(false);
				}
			}
		});
	}


	// Functions on Basket Quantity Change - Those are triggered by the buttons on checkout page

	$(document).on('change', '.basket-product-qty', function () {
		var d = new Date();
		var now = d.getTime();
		var upd = localStorage.getItem('updating_date');
		if(!upd) {
			localStorage.setItem('updating_date', now);
		} 
		var that = this;

		// Update Quantity on Button
		var key = $(that).attr('data-key');
		var quantity = $(that).val();
		$('.basket-product-update-btn[data-key="' + key + '"]').attr('data-quantity', quantity);

		//console.log($(this).find("option:selected").attr('value'));  

		// Only trigger the change if we're on the initial call - one millisecond later we won't be, preventing the loop
		if(localStorage.getItem('updating_date') == d.getTime()) {
			$('.basket-product-qty').trigger('change')
			basket_product_update(key, quantity);
		}
		setTimeout(function() {
			localStorage.removeItem('updating_date');
		}, 1);

		
	});


	// Basket Remove Button

	$(document).on('click', '.basket-product-remove-btn', function () {

		var key = $(this).attr('data-key');

		basket_product_remove(key);

	});

	// Basket Update Button

	$(document).on('click', '.basket-product-update-btn', function () {

		var key = $(this).attr('data-key');
		var quantity = $(this).attr('data-quantity');

		basket_product_update(key, quantity);

	});

	// Apply Discount Code Button		


	$(document).on('click', '.basket-apply-discount-code-btn', function () {

		var code = $(this).parents('.discount-wrapper').find('.discount-code').val();

		console.log(code);

		basket_apply_discount_code(code); //function an line 1088

	});

	// Remove Discount Code Button		

	$(document).on('click', '.basket-remove-discount-code-btn', function () {

		basket_remove_discount_code(); //trigger the AJAX function on functions.php

	});

	// If Page is Cart
	if ($('body').hasClass('page-template-basket')) {
		// Buy Now Button
		$('.product-remove').on('click', function() {
			$(this).parents('.product-wrapper').slideUp(400);
		});

		//$('.quantity #prod_quantity__select').select2().each(function () {
		//	var quantity = $(this).attr('data-quantity');
		//	$(this).val(quantity).trigger('change');
		//});
	}


	// If Page is Checkout
	if ($('body').hasClass('page-template-template-checkout')) {
		// Init Basket
		$('.basket-product-qty').select2().each(function () {
			var quantity = $(this).attr('data-quantity');
			$(this).val(quantity).trigger('change.select2');
		});

		
		// Make Personal Details Checkout Step Show First

		$('.checkout-step.personal-details').addClass('active');
		$('.checkout-steps').css('height', $('.checkout-step.personal-details').outerHeight(false));

		setTimeout(function () {

			$('.wc-credit-card-form .stripe-source-errors').prependTo('.wc-credit-card-form');

		}, 5000);

		$(document).on('click', '#place_order', function () {

			var interval = setInterval(move_payment_errors, 500);

			function move_payment_errors() {

				$('.woocommerce-NoticeGroup').prependTo('.wc-credit-card-form');

				if ($('.wc-credit-card-form').find('.woocommerce-NoticeGroup').length > 0) {
					stop_move_payment_errors();
				}
			}

			function stop_move_payment_errors() {
				clearInterval(interval);
			}

		});

	}

// Change Checkout Steps

	$(document).on('click', '.payment-methods-step-btn', function () {

		var data = {
			forename: $('#billing_first_name').val(),
			surname: $('#billing_last_name').val(),
			company: $('#billing_company').val(),
			email: $('#billing_email').val(),
			phone: $('#billing_phone').val(),
			address1: $('#billing_address_1').val(),
			address2: $('#billing_address_2').val(),
			city: $('#billing_city').val(),
			county: $('#billing_state').val(),
			postcode: $('#billing_postcode').val()
		};
		validate_checkout_personal_details(data);

		if( wSize <= 992 ){
			$('.checkout-basket').hide('slow');
			 $("html, body").animate({ scrollTop: 0 }, "slow");
 			 return false;
			}

	});

	//TO CHECK

	function checkout_start_loading() {
	$('.checkout-loading').addClass('active');
	}

	function checkout_end_loading(delay) {
		$('.checkout-loading').removeClass('active');
	}

	function update_account_start_loading() {
		$('.update-form .row').fadeTo(250, 0);
		setTimeout(function () {
			$('.update-account-loading').addClass('active');
		}, 250);
	}

	function update_account_end_loading(delay) {
		setTimeout(function () {
			$('.update-account-loading').removeClass('active');
			setTimeout(function () {
				$('.update-form .row').fadeTo(250, 100);
			}, 250);
		}, delay);
	}


	function checkout_details_refresh(step) {

		if (step == 'personal-details') {

			window.location.href = '/checkout?step=pd';

		} else if (step == 'payment-methods') {

			window.location.href = '/checkout?step=pm';

		}
	}

	function basket_refresh(checkout_loading) {

		setTimeout(function () {

			$.ajax({
				url: ajax.url,
				type: 'POST',
				data: { 'action': 'wc_basket_refresh' },
				success: function (response) {

					$('.basket-popout .inner').html(response);
					$('.basket-product-qty').select2().each(function () {
						var quantity = $(this).attr('data-quantity');
						$(this).val(quantity).trigger('change');
					});

					//popout_end_loading('basket', 0);

					//$('.basket-popout').animate({ scrollTop: 0 }, 250);

				}
			});

			$.ajax({
				url: ajax.url,
				type: 'POST',
				data: { 'action': 'wc_checkout_basket_refresh' },
				success: function (response) {

					$('.checkout-basket .inner').html(response);
					$('.basket-product-qty').select2().each(function () {
						var quantity = $(this).attr('data-quantity');
						$(this).val(quantity).trigger('change');
					});

					if (checkout_loading !== 'no') {
						checkout_end_loading(0);
					}

					//$('.basket-popout').animate({ scrollTop: 0 }, 250);

				}
			});

		}, 1500);

	}

	function basket_product_update(key, quantity) {

		// to check ... popout_start_loading('basket');
		checkout_start_loading('basket', 0);

			$.ajax({
				url: ajax.url,
				type: 'POST',
				data: { 'action': 'wc_basket_product_update', 'key': key, 'quantity': quantity },
				success: function () {

					if ($('body').hasClass('page-template-template-checkout')) {
						//basket_refresh('no');

						if ($('.checkout-step.personal-details').hasClass('active')) {
							checkout_details_refresh('personal-details');
						} else if ($('.checkout-step.payment-methods').hasClass('active')) {
							checkout_details_refresh('payment-methods');

						}
					} else {
						basket_refresh();
					}

				}
			});

	}


		function basket_product_remove(key) {

			//popout_start_loading('basket');
			checkout_start_loading('basket', 0);

			$.ajax({
				url: ajax.url,
				type: 'POST',
				data: { 'action': 'wc_basket_product_remove', 'key': key },
				success: function () {

					if ($('body').hasClass('page-template-template-checkout')) {
						basket_refresh('no');
						if ($('.checkout-step.personal-details').hasClass('active')) {
							checkout_details_refresh('personal-details');
						} else if ($('.checkout-step.payment-methods').hasClass('active')) {
							checkout_details_refresh('payment-methods');
						}
					} else {
						basket_refresh();
					}

				}
			});

		}

		function basket_apply_discount_code(code) {

		//popout_start_loading('basket');
		checkout_start_loading();

		$.ajax({
				url: ajax.url,
				type: 'POST',
				data: { 'action': 'wc_basket_apply_discount_code', 'code': code },
				success: function (response) {
					if (response.length > 0) {
						basket_show_error(response);
					} else {
						if ($('body').hasClass('page-template-template-checkout')) {
							//basket_refresh('no');
							if ($('.checkout-step.personal-details').hasClass('active')) {
								checkout_details_refresh('personal-details');
							} else if ($('.checkout-step.payment-methods').hasClass('active')) {
								checkout_details_refresh('payment-methods');
							}
						} else {
							//basket_refresh();
						}
					}
				}
			});

		}


		function basket_remove_discount_code() {

			//popout_start_loading('basket');
			checkout_start_loading();

			$.ajax({
				url: ajax.url,
				type: 'POST',
				data: { 'action': 'wc_basket_remove_discount_code' },
				success: function () {
					if ($('body').hasClass('page-template-template-checkout')) {
						//basket_refresh('no');
						if ($('.checkout-step.personal-details').hasClass('active')) {
							checkout_details_refresh('personal-details');
						} else if ($('.checkout-step.payment-methods').hasClass('active')) {
							checkout_details_refresh('payment-methods');
						}
					} else {
						basket_refresh();
					}
				}
			});

		}

		function basket_show_error(message) {

		$('.basket-errors').show().find('.inner').empty().append('<h6 class="fs22 error">' + message + '</h6>');
			//popout_end_loading('basket', 0);
			checkout_end_loading(0);

			$('.basket-popout').animate({ scrollTop: 0 }, 250);

			if ($('body').hasClass('page-template-template-checkout') && $(window).width() < 992) {
				$('html, body').animate({ scrollTop: 0 }, 250);
				setTimeout(function () {
					$('.checkout-steps').css('height', $('.checkout-step.payment-methods').outerHeight(false));
				}, 250);
			}

		}

		function forgot_password_show_error(message) {
		    $('.forgot-password-errors').show().find('.inner').empty().append('<h6>' + message + '</h6>');
		   // popout_end_loading('forgot-password', 0);
		}


		function forgot_password_submit(email, pass) {

		   // popout_start_loading('forgot-password');

		    $.ajax({
		        url: ajax.url,
		        type: 'POST',
		        data: { 'action': 'wc_forgot_password_submit', 'email': email },
		        success: function (response) {

		            if (response.length > 0) {

		                forgot_password_show_error(response);

		            } else {

		                $('.forgot-password-email').val('');
		                forgot_password_thanks();

		            }

		        }
		    });
		}


		function forgot_password_thanks() {
			$('.forgot-password-wrapper').hide();
			$('.forgot-password-thanks-wrapper').show();
			popout_end_loading('forgot-password', 0);
		}

		function update_account_show_error(message) {
			$('.update-errors').show().find('.inner').empty().append('<ul>' + message + '</ul>');
			update_account_end_loading(0);
			$('html, body').animate({ scrollTop: 0 }, 250);
		}

		function update_account_submit(user_id, data) {

			update_account_start_loading();

			$.ajax({
				url: ajax.url,
				type: 'POST',
				data: { 'action': 'wc_update_account_submit', 'user_id': user_id, 'data': data },
				success: function (response) {
					if (response.length > 0) {
						update_account_show_error(response);
					} else {
						window.location.reload(false);
					}
				}
			});

		}


		function reset_password_show_error(message) {
			$('.reset-password-errors').show().find('.inner').empty().append('<ul>' + message + '</ul>');
		}

		function reset_password_submit(data) {

			$.ajax({
				url: ajax.url,
				type: 'POST',
				data: { 'action': 'wc_reset_password_submit', 'data': data },
				success: function (response) {

					if (response.length > 0) {
						reset_password_show_error(response);
					} else {
						window.location.href = '/';
					}

				}
			});

		}

		function validate_checkout_show_error(message) {
			$('.checkout-errors').show().find('.inner').empty().append('<ul>' + message + '</ul>');
			checkout_end_loading(0);
		}

		function validate_checkout_personal_details(data) {

			checkout_start_loading();

			$.ajax({
				url: ajax.url,
				type: 'POST',
				data: { 'action': 'wc_validate_checkout_personal_details', 'data': data },
				success: function (response) {
					if (!response) {
						checkout_update_details(data);
					} else {
						validate_checkout_show_error(response);
						$('html, body').animate({ scrollTop: 0 }, 250);
						$('.checkout-steps').css('height', $('.checkout-step.personal-details').outerHeight(false));
					}
				}
			});

		}
		function checkout_update_details(data) {

			$.ajax({
				url: ajax.url,
				type: 'POST',
				data: { 'action': 'wc_checkout_update_details', 'data': data },
				success: function (response) {
					$('.checkout-step').not('.payment-methods').removeClass('active');
					setTimeout(function () {
						checkout_end_loading(0);
						$('html, body').animate({ scrollTop: 0 }, 250);
						$('.checkout-steps').css('height', $('.checkout-step.payment-methods').outerHeight(false));
						$('.checkout-step.payment-methods').addClass('active');
						//I'm hidinf the payment methods button because each method(Stripe/Google Pay, Apple Pay) has its own payment button
						$('.checkout-step-btn-wrapper').hide();
						
					}, 500);
				}
			});

		}

	//WAYPOINTS
		//Waypoint
	if ( wSize >= 992 ) {

		$( '.fade_in_down' ).waypoint( function( direction ) {
			myfunc_fadeInDown( this.element, direction ); //when using waypoint, this refers to the waypoint object
		}, {
			offset: '90%'
		} );

		$( '.fade_in_left' ).waypoint( function( direction ) {
			myfunc_fadeInLeft( this.element, direction );
		}, {
			offset: '90%'
		} );

		$( '.fade_in_right' ).waypoint( function( direction ) {
			myfunc_fadeInRight( this.element, direction );
		}, {
			offset: '90%'
		} );

		$( '.fade_in_up' ).waypoint( function( direction ) {
			myfunc_slideInUp( this.element, direction );
		}, {
			offset: '90%'
		} );

		$( '.fixed-img' ).waypoint( function( direction ) {
			myfixedOnView( this.element, direction );
		}, {
			offset: '0%'
		} );

		$( '.end_fixed_scroll' ).waypoint( function( direction ) {
			myAbsoluteOnView( this.element, direction );
		}, {
			offset: '90%'
		} );


		//defining animations functions

		function myfixedOnView( target, direction ) {
			if ( direction === "down" ) {
				$( target ).addClass( "on-view" );
				$( target ).css( 'top', topSidebarHeight );
			}
			if ( direction === "up" ) {
				$( target ).removeClass( "on-view" );
			}
		}

		function myAbsoluteOnView( target, direction ) {
			if ( direction === "down" ) {
				$( '.fixed-img' ).css( 'z-index', '0' );

			}
			if ( direction === "up" ) {
				$( '.fixed-img' ).css( 'z-index', '2' );

			}
		}

		function myfunc_fadeInDown( target, direction ) {
			if ( direction === "down" ) {
				$( target ).addClass( "animatetrigger animated fadeInDown" );
			}
		}


		function myfunc_fadeInLeft( target, direction ) {
			if ( direction === "down" ) {
				$( target ).removeClass( "hidden" );
				$( target ).addClass( "animatetrigger animated fadeInLeft" );
			}
		}

		function myfunc_fadeIn( target, direction ) {
			if ( direction === "down" ) {
				$( target ).removeClass( "hidden" );
				$( target ).addClass( "animatetrigger animated fadeIn" );
			}
		}

		function myfunc_fadeInRight( target, direction ) {
			if ( direction === "down" ) {
				$( target ).removeClass( "hidden" );
				$( target ).addClass( "animatetrigger animated fadeInRight" );
			}
		}

		function myfunc_slideInUp( target, direction ) {
			if ( direction === "down" ) {
				$( target ).removeClass( "hidden" );
				$( target ).addClass( "animatetrigger animated slideInUp" );
			}
		}

		function myfunc_zoomIn( target, direction ) {
			if ( direction === "down" ) {
				$( target ).removeClass( "hidden" );
				$( target ).addClass( "animatetrigger animated zoomIn" );
			}
		}

	} else {
		//mobile animations

		/*
		   $('.anitrigger').waypoint(function(direction) {
		        if ('down' !== direction) return;
		        $(this[0, 'element']).addClass("animatetrigger");
		      }, {
		        offset: '100%'
		      });
	    
		*/


		$( '.anitrigger' ).waypoint( function( direction ) {
			myfunc_inView( this.element, direction );
		}, {
			offset: '90%'
		} );

		function myfunc_inView( target, direction ) {
			if ( direction === "down" ) {
				$( target ).removeClass( "hidden" );
				$( target ).addClass( "animatetrigger" );
			}
		}
	}

	/* NOT Implemented - Load More Alerts

	//Alerts
	$('.alert').each(function () {

		var that = this;

		var excerpt_height = $(that).find('.excerpt').outerHeight(true);
		var content_height = $(that).find('.content').outerHeight(true);

		$(that).find('.excerpt-content').css('height', excerpt_height);
		$(that).find('.excerpt').attr('data-height', excerpt_height);
		$(that).find('.content').attr('data-height', content_height);

		setTimeout(function () {
			$(that).find('.content').hide();
		}, 1);

	});

	$(document).on('click', '.alert .load-more', function () {

		var that = $(this).parent().parent();
		var content_height = that.find('.content').attr('data-height');

		that.addClass('read');
		that.find('.excerpt-content').animate({ opacity: 0 }, 250);
		that.find('.load-more').animate({ opacity: 0 }, 250);

		if (that.hasClass('read')) {
			var user_id = that.attr('data-user-id');
			var item_id = that.attr('data-alert-id');
			save_item('alert', user_id, false, item_id);
		}

		setTimeout(function () {
			that.find('.excerpt-content').animate({ height: content_height }, 250);
			that.find('.load-more').animate({ height: 0, padding: 0 }, 250);
			that.find('.excerpt').hide();
			that.find('.content').show();
		}, 250);

		setTimeout(function () {
			$(that).find('.excerpt-content').animate({ 'opacity': 1 }, 250);
		}, 500);

	});
	*/

	// Styled Checkbox Action

	$(document).on('click', '.checkbox-wrapper', function () {
		$(this).toggleClass('active');
		$(this).find('input').prop('checked', !$(this).find('input').prop('checked'));
	});
	
	//Send data to functions.php line 1165 -wc_update_allow_comms()  
	function update_allow_comms(user_id, allow_comms) {

		$.ajax({
			url: ajax.url,
			type: 'POST',
			data: { 'action': 'wc_update_allow_comms', 'user_id': user_id, 'allow_comms': allow_comms },
		});

	}

	//Update allow comments on My Aleerts on dashboard
	$('.checkbox-update-allow-comms').on('click', function () {

		var that = this;

		setTimeout(function () {

			if ($(that).find('input[type="checkbox"]').is(':checked')) {
				var allow_comms = 'true';
			} else {
				var allow_comms = 'false';
			}

			var user_id = $(that).find('input[type="checkbox"]').attr('data-user-id');
			//above to send data to
			update_allow_comms(user_id, allow_comms);

		}, 1);

	});


});
